<template> 
	<div class="pagination-container" v-if="totalCount > 0" :class="{ 'mt-4': showMargin }"> 
		<div v-if="showPageSize"> 
			<v-select class="m-0 p-0 paginationSelect" @change="pageSizeChanged" v-model="pageSize" :items="[10, 20, 50, 100]"
				style="min-width: 90px;"></v-select>
		</div> 
		<div class="pagination">
			<a>
				<div class="previous-page" :class="{ 'disabled': isPrevPageDisabled }" @click="goToPreviousPage()"><i class="fa fa-angle-left"></i></div>
			</a>
			<div class="size-12 disabled">
				{{ getPagingRecordsDisplay }}
			</div>
			<a>
				<div class="next-page" :class="{ 'disabled': isNextPageDisabled }" @click="goToNextPage()"><i class="fa fa-angle-right"></i></div>
			</a>
		</div> 
	</div>
</template>

<style>
.paginationSelect>div>.v-input__slot { margin-bottom: 0px; }


.pagination-container {
  display: flex;
  justify-content: space-between; /* Distribute items evenly */
  align-items: center; /* Vertically center items */
  flex-shrink: 0;
}

.pagination-container.rtl {
  /* RTL specific styles */
  flex-direction: row-reverse; /* Reverse the order for RTL */
}

</style>

<script>
	export default {
		name: 'Pagination',
		props: {
			totalCount: { type: Number, default: 0 },
			pageSize: { type: Number, default: 0 },
			pageIndex: { type: Number, default: 0 },
			showPageSize: { type: Boolean, default: true },
			arrayIndex:{ type: Number, default: 0 },
			showMargin:{ type: Boolean, default: true }
		},
		data: () => ({

		}),
		mounted() {

		},
		watch: {

		},
		computed:
		{
			getPagingRecordsDisplay() 
			{
				let pageItemsCount = this.getPageItemsCount();

				if (pageItemsCount > this.totalCount)
					pageItemsCount = this.totalCount 

				return `${pageItemsCount} ${this.$t("res_Label_Of")} ${this.totalCount}`;
			},
			isNextPageDisabled() 
			{
				let pageItemsCount = this.getPageItemsCount();
				return pageItemsCount >= this.totalCount;
			},
			isPrevPageDisabled() 
			{
				return this.pageIndex < 1;
			}
		},
		methods: 
		{
			getPageItemsCount() 
			{
				return ((this.pageIndex) * this.pageSize) + this.pageSize;
			},
			goToNextPage() 
			{
				this.pageIndex++;

				this.$emit('pageIndexChanged', 
				{
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
					arrayIndex:this.arrayIndex
				});
			},
			pageSizeChanged() 
			{
				this.$emit('pageIndexChanged', 
				{
					pageIndex: 0,
					pageSize: this.pageSize,
					arrayIndex:this.arrayIndex
				});
			},
			goToPreviousPage() 
			{
				this.pageIndex--;
				this.$emit('pageIndexChanged', 
				{
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
					arrayIndex:this.arrayIndex
				});
			},
		}
	}
</script>